// utils/encryption.js
import CryptoJS from 'crypto-js';

const SECRET_KEY = '98ff1934947fb5f939b9803ae6d09fa7';

export const encryptData = (text) => {
  // Random IV (16 bytes)
  const iv = CryptoJS.lib.WordArray.random(16);
  
  // Hash the key to get the same 32-byte key as in backend
  const key = CryptoJS.SHA256(SECRET_KEY);

  // AES Encryption using CBC mode and PKCS7 padding
  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return {
    iv: iv.toString(CryptoJS.enc.Hex),
    value: encrypted.ciphertext.toString(CryptoJS.enc.Hex)
  };
};
